import AxiosLeanist from "./AxiosLeanist.js";

class ModelLeanist {

  constructor(resource) {
    this.resource = resource;
  }

  getAll() {
    return AxiosLeanist.get(`${this.resource}`);
  }

  get(id) {
    return AxiosLeanist.get(`${this.resource}/?id=${id}`);
  }

  getParams(params) {
    return AxiosLeanist.get(`${this.resource}`, {params: params});
  } 

  create(params) {
    return AxiosLeanist.post(`${this.resource}/`, params);
  }

  update(id, params) {
    return AxiosLeanist.put(`${this.resource}/${id}/`, params);
  }

  delete(id) {
    return AxiosLeanist.delete(`${this.resource}/${id}/`);
  }

}

export default ModelLeanist;
